import { Input, makeStyles } from '@material-ui/core';
import { grey, red } from '@material-ui/core/colors';
import { RepeatRounded } from '@material-ui/icons';
import React,{useState, useEffect} from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import { convUid } from '../../albCommonModule';
import { convHankaku, getFormDatas, getLodingStatus, parseDate, qslcta, zp } from '../../commonModule';
import { LoadErr, LoadingSpinner } from '../common/commonParts';
import { SelectGp } from '../common/FormPartsCommon';
import { ScheLokedDisplay } from '../common/materialUi';
import { DateInput } from '../common/StdFormParts';
const useStyle = makeStyles({
  root:{
    margin:'80px auto', minWidth: 1040, width: '80%', maxWidth: 1280,
    '& .noBorder': {border: 'none'},
    '& .diabledRow': {opacity: .6},
    '& .clickable': {cursor: 'pointer'},
    '& .MuiInputBase-input.Mui-disabled ': {background: grey[100]}
  }
});

const sample = () => {
  const preContDate = qslcta('.flxRow input[name=preContDate]');
  const preEndDate = qslcta('.flxRow input[name=preEndDate]');
  const fvals = getFormDatas([preContDate, preEndDate]);
  console.log(fvals);
}

// 利用者契約情報の編集
const UsersContractInfoMain = () =>{
  const classes = useStyle();
  const allstate = useSelector(state=>state);
  const {users,stdDate} = allstate;
  const schLocked = allstate.schedule.locked;
  const thisMonth = stdDate.slice(0, 7);
  const histry = useHistory();
  // deep copy
  const trgUsers = JSON.parse(JSON.stringify(users));
  // 当月に契約日含まれる利用者にフラグ立て
  trgUsers.forEach(e => {
    e.target = 
    (e.contractDate.includes(thisMonth) || e.contractEnd.includes(thisMonth))?
    true: false;
  });
  // ターゲットユーザーを上位に
  trgUsers.sort((a, b)=>(a.target? -1: 1));
  // 表示行数分の配列になるので初期値を設定しておく
  const formStateInit = {
    select: '', preVol: '', preContDate: '', preEndDate: '', preLineNo: '',
    preUseCount: '',
  };
  
  // フォームの値 有効値の数だけデータオブジェクトを配列化する
  const [val, setVal] = useState(
    Array(trgUsers.filter(e=>e.target).length)
    .fill(0).map(e=>({...formStateInit}))
  );
  // 日付の値　DateInputで使う
  // const [dateVal, setDateVal] = useState('');
  // 日付の値を変更するプロパティ
  // const [datePos, setDatePos] = useState({p: 0, label: ''});
  // ステイトの配列の中身を変更する　ユーザー分だけ初期値を用意
  const selectOpt = ['変更', '新規', '終了'];
  const handleChange = (e, i, fname, v) => {
    const name = fname? fname: e.target.name;
    const t = [...val];
    t[i][name] = v? v: e.target.value;
    setVal(t);
  }
  const handleBlur = (e, i) => {
    const name = e.target.name;
    let v = e.target.value;
    v = convHankaku(v);
    const t = [...val];
    t[i][name] = v;
    setVal(t);
  }
  // 利用者情報の編集
  const handleClick = (uid) => {
    if (schLocked) return false;
    uid = convUid(uid).n;
    const newLoc = '/users/edit' + uid + '/';
    histry.push(newLoc);
  }
  const uList = trgUsers.map((e, i)=>{
    let thisOpts;
    // 契約日等の状態により選択肢を変更する
    if (!e.contractDate.includes(thisMonth)){
      thisOpts = selectOpt.filter(e=>e !== '新規');
    }
    if (!e.contractEnd.includes(thisMonth)){
      thisOpts = selectOpt.filter(e=>e !== '終了');
    }
    const inRange = (i < val.length);
    const disableRow = inRange? '': 'diabledRow';
    return (
      <div className={'userRow flxRow noBorder ' + disableRow} key={i}>
        <div className='wmin center'>{i + 1}</div>
        <div className='w15 clickable' onClick={() => handleClick(e.uid)}>
          {e.name}
        </div>
        <div className='w10'>{e.contractDate}</div>
        <div className='w10'>{e.contractEnd}</div>
        <div className='w07 center'>{e.lineNo}</div>
        <div className='w07 center'>{e.volume}</div>
        <div className='w07'>
          {inRange &&
            <SelectGp
              onChange={(e) => handleChange(e, i, 'select')}
              name={'select'} nullLabel='なし'
              value={val[i].select} noLabel opts={thisOpts}
              disabled={!e.target}
            />
          }
        </div>
        <div className='w10'>
          {inRange &&
            <Input
              name='preLineNo' value={val[i].preLineNo}
              onChange={(e)=> handleChange(e, i)}
              onBlur={e => handleBlur(e, i)}
              disabled={val[i].select !== '変更'} // inputType = 'num'
            />
          }
        </div>

        <div className='w10'>
          {inRange &&
            <Input
              name='preVol' value={val[i].preVol}
              onChange={(e)=> handleChange(e, i)}
              onBlur={e => handleBlur(e, i)}
              disabled={val[i].select !== '変更'} // inputType = 'num'
            />
          }
        </div>
        <div className='w10'>
          {inRange &&
            <DateInput
              name='preContDate' def={val[i].preContDate}
              label = '' noLabel helperTextShort
              disabled={val[i].select !== '変更'}
            />
          }
        </div>
        <div className='w10'>
          {inRange &&
            <DateInput
              name='preEndDate' def={val[i].preEndDate}
              label = '' noLabel helperTextShort
              disabled={val[i].select !== '変更'}
            />
          }

        </div>
        <div className='w10'>
          {inRange &&
            <Input
              name='preUseCount' value={val[i].preUseCount}
              onChange={(e)=> handleChange(e, i)}
              onBlur={e => handleBlur(e, i)}
              disabled={val[i].select === ''} // inputType = 'num'
            />
          }
        </div>
      </div>
    )
  });
  // const NoUsers = () => {
  //   const style = {textAlign: 'center', color: red[800]}
  //   if (trgUsers.length) return null;
  //   return (<>
  //     <div style={style}>表示する利用者がいません。</div>
  //     <div style={style}>当月契約または当月契約終了の利用者が対象になります。</div>
  //     </>)
  // }
  // if (!trgUsers.length) return <NoUsers/>
  const Titles = () => {
    return(
      <div className='flxTitle'>
        <div className='wmin lower'>No</div>
        <div className='w15 lower'>利用者名</div>
        <div className='w10 lower'>契約日</div>
        <div className='w10 lower'>契約終了日</div>
        <div className='w07 lower'>契約<br/>支給量</div>
        <div className='w07 lower'>記入欄<br/>番号</div>
        <div className='w07 lower'>種別</div>
        <div className='w07 lower'>契約<br/>支給量</div>
        <div className='w10 lower'>記入欄<br/>番号</div>
        <div className='w10 lower'>契約日</div>
        <div className='w10 lower'>契約<br/>終了日</div>
        <div className='w10 lower'>前回終了時の<br/>提供量</div>
      </div>
    )
  }
  return (<>
    <div className={'AppPage ' + classes.root}>
      <Titles/>
      {uList}
    </div>
    <ScheLokedDisplay/>
  </>)
}

const UsersContractInfo = () => {
  const allstate = useSelector(state=>state);
  const ls = getLodingStatus(allstate);
  if (ls.loaded && !ls.error){
    return (<UsersContractInfoMain/>);
  }
  else if (!ls.loaded){
    return (<LoadingSpinner/>)
  }
  else {
    return (<LoadErr loadStatus={ls} errorId={'E32592'} />)
  }
}

export default UsersContractInfo;
